var AdminController = (function () {
    function AdminController($state, settings, env) {
        this.$state = $state;
        this.settings = settings;
        this.env = env;
    }
    AdminController.prototype.$onInit = function () {
        if (this.$state.current.name === 'admin') {
            this.$state.go('admin.main');
        }
    };
    AdminController.$inject = ['$state', 'settings', 'env'];
    return AdminController;
}());
var AdminComponent = (function () {
    function AdminComponent() {
        this.templateUrl = 'admin.html';
        this.controllerAs = 'vm';
        this.controller = AdminController;
    }
    return AdminComponent;
}());
angular
    .module('application')
    .component('adminSection', new AdminComponent());

//# sourceMappingURL=admin.component.js.map
